module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_6005.3ae5e417.png";